// Winning a deal is the one stage change that is not just a step along the pipeline:
// it moves the row onto a different screen, opens the billing paths, and stamps
// converted_at. So it gets a dialog that says all of that in words beforehand rather
// than asking "are you sure" about an unnamed consequence.
//
// Two states: confirm → done. Converting is never refused — a lead converts on its
// name alone (see STAGE_GATES) — so there is nothing to collect here; the errors that
// remain are real ones (a lost session, a lead deleted meanwhile). The done state
// carries the "it moved to the board" message, because that is exactly the moment the
// row disappears from the screen behind the dialog.
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { clientsApi } from '../../api';
import he from '../../i18n/he';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { ErrorText } from '../../components/Loader';

export default function ConvertModal({ lead, onClose, onConverted }) {
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const convert = async () => {
    setBusy(true);
    setError(null);
    try {
      await clientsApi.advanceStage(lead.id, 'active');
      setDone(true);
      onConverted(); // refresh behind the dialog — this row is not a lead any more
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <Modal title={he.leads.convertedTitle} onClose={onClose}>
        <p className="convert-name">{lead.name}</p>
        <p>{he.leads.convertedBody}</p>
        <div className="actions">
          {/* The work board, which is at /board since היום שלי took the landing page.
              The button names the board, so it has to go to the board. */}
          <Link to="/board"><Button>{he.leads.toBoard}</Button></Link>
          <Button variant="subtle" onClick={onClose}>{he.common.close}</Button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title={he.leads.convert}
      onClose={onClose}
      onSave={convert}
      saveLabel={he.leads.convert}
      saveDisabled={busy}
    >
      <p className="convert-name">{lead.name}</p>
      <ul className="convert-points">
        {he.leads.convertPoints.map((point) => <li key={point}>{point}</li>)}
      </ul>
      {error && <ErrorText error={error} />}
    </Modal>
  );
}
